import FormControlSwitch from './form_control_switch';

export default FormControlSwitch;
